<template>

<!--    <div class="logo-text1"><strong>International Cinematographers Guild</strong></div>-->
<!--    <div class="logo-text2">I.A.T.S.E. Local 667</div>-->
    <div class="tw-flex tw-flex-col tw-w-full">
        <hr class="mt-0 mb-4 border-dark-grey w-full center_focus_strong">
        <div class="logo">
            <img :src="logo_base64" alt="Logo" width="45" height="43">
        </div>
        <div class="logo-text1"><strong>International Cinematographers Guild</strong></div>


        <div class="tw-text-lg text-center">International Cinematographers Guild</div>
        <!-- General Section -->
        <div class="tw-w-full lg:tw-w-3/4">
            <div class="tw-text-sm tw-font-light tw-pb-3">
                <div class="tw-text-sm tw-pb-3">{{ this.printedDate }}</div>
            </div>
            <div class="tw-w-full lg:tw-w-3/4">
                <div class="tw-text-sm tw-font-light">
                    <div class="tw-text-sm">{{ member.first_name + ' ' + member.last_name }}</div>
                    <div class="tw-text-sm" v-if="mailing_address">{{ mailing_address.address1}}</div>
                    <div class="tw-text-sm" v-if="mailing_address">{{ mailing_address.city_and_province}}</div>
                    <div class="tw-text-sm tw-pb-3" v-if="mailing_address">{{ mailing_address.postal_code}}</div>
                </div>
            </div>
            <div class="tw-w-full lg:tw-w-3/4">
                <div class="tw-text-sm tw-font-light">
                    <p>Dear {{member.first_name}}, </p>
                    <p v-if="type === 'payup'" class="description" ref="payup_notice" v-html="contents.payup_notice.body"></p>
                    <p v-else-if="type === 'expulsion'" class="description" ref="payup_notice" v-html="contents.expulsion_notice.body"></p>
                </div>
            </div>
            <div class="tw-w-full lg:tw-w-3/4">
                <div class="tw-text-sm tw-font-light">
                    <v-col cols="3" class="d-flex justify-end">
                        <div v-if="treasurer.signature" class="signature first-image">
                            <img :src="`/storage/signatures/${treasurer.signature.split('/').pop()}`" alt="Treasure's Signature">
                        </div>
                    </v-col>
                    <p class="tw-text-sm" v-if="treasurer">{{ treasurer.name + ', ' + treasurer.title}}<br>
                        on behalf of the Executive Board of I.A.T.S.E. Local 667
                    </p>
<!--                    <p class="tw-text-sm" v-if="type === 'expulsion'">on behalf of the Executive Board of I.A.T.S.E. Local 667</p>-->
                    <p class="tw-text-sm" v-if="type === 'expulsion'">encl.</p>
<!--                    TODO: make this a variable-->
                    <p class="tw-text-sm" v-if="type === 'expulsion'">cc: Leta Kennedy Plan Administrator </p>
                    <p class="tw-text-sm" v-if="type === 'expulsion'">I.A.T.S.E. 667/669 Health & Welfare Trust</p>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import SmartTable from "@/Generic/SmartTable";
import AppLayout from "@/Layouts/AppLayout.vue";
import InternalHeader from "@/Generic/InternalHeader.vue";


export default {
    name: "ActivityFullReport",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        InternalHeader,

    },
    props: {
        'member': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return {}
            }
        },
        'mailing_address': {
            type: Object,
            required: false,
            default: function () {
                return {}
            }
        },
        'treasurer': {
            type: Object,
            required: false,
            default: function () {
                return {}
            }
        },
        'type': {
            type: String,
            required: false
        },
        'logo_base64': {
            type: String,
            required: false
        },
    },
    data() {
        return {
            member: this.input,
        }
    },
    computed: {
        printedDate() {
            let printedDate = new Date();
            return printedDate.getFullYear()+'/'+(printedDate.getMonth()+1)+'/'+printedDate.getDate();
        }
    },
    methods: {

    },
}

window.onafterprint = function(event) { window.close() };
window.print();


</script>

<style scoped>
.total-by-year {
    color: #3c47d1;
}
.data-center{
    text-align: center;
}
.production{
    background-color: #eeeeee;
}
.total{
    color: #3c47d1 !important;
}
tr.total[key^="total-"] {
    color: #3c47d1;
}
tr.total {
    color: #3c47d1 !important;
}
div.v-item-group.theme--light.v-expansion-panels.v-expansion-panels--accordion.v-expansion-panels--flat > div > button{
   padding-left: 0px !important;
   padding-right: 0px !important;
}
a{
    color: #0000EE;
    text-decoration: underline;
}

.logo {
    max-width: 100%;
    max-height:100%;
    position: absolute;
    top: 12px;
    left: 12px;
}

.logo-text1 {
    position: absolute;
    top: 12px;
    left: 62px;
    font-size: 12px;
    font-weight: bold;
}

div {
    font-family: ABCFavorit;
}

p {
    font-family: ABCFavorit;
}
</style>


<style type="text/css" media="print">
@media print {
    @page {
        margin-top: 30px;
        margin-bottom: 0;
    }
    body {
        //padding-top: 30px;
        //margin-top: 60px;
        //margin-bottom: -60px;
        //padding-bottom: -30px ;
    }
}
</style>
